export default __webpack_public_path__ + "static/media/trash.0cd403b7.svg";